<template>
  <div>
    <v-container fluid>
      <print mode="testPlan" :releaseNoteList="testPlanList"></print>
    </v-container>
  </div>
</template>

<script>
import Print from "@/components/printReleaseNote";

export default {
  name: "printTestPlan",
  components: {
    Print,
  },
  computed: {
    testPlanList() {
      return this.$route.params.testPlanList;
    },
  },
};
</script>
